import { motion } from 'framer-motion';
import { Camera, Award, Users } from 'lucide-react';

const stats = [
  { icon: Camera, value: '500+', label: 'Sesiones realizadas' },
  { icon: Award, value: '15', label: 'Años de experiencia' },
  { icon: Users, value: '300+', label: 'Clientes satisfechos' },
];

export const About = () => {
  return (
    <section id="sobre-mi" className="py-20 md:py-32 bg-background" data-testid="about-section">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="aspect-[4/5] relative overflow-hidden w-3/4 mx-auto">
              <img
                src="https://customer-assets.emergentagent.com/job_f864398d-c2a7-4f36-bb66-c3ad5f7fb781/artifacts/t2x6et65_YoBananaCamaraRedonda.png"
                alt="Jon Quintano"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative frame */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border border-border -z-10" />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <span className="text-sm uppercase tracking-widest text-muted-foreground block mb-4">
              Sobre Mí
            </span>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight mb-6">
              Jon Quintano
            </h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed mb-8">
              <p>
                Soy un fotógrafo profesional especializado en capturar momentos únicos con un enfoque 
                artístico y emotivo. Con más de 15 años de experiencia, he desarrollado un estilo 
                distintivo que combina la elegancia del retrato clásico con la frescura de la 
                fotografía contemporánea.
              </p>
              <p>
                Mi pasión por la luz y la composición me ha llevado a trabajar en bodas, eventos 
                corporativos, sesiones editoriales y proyectos de paisaje. 
                Cada proyecto es una oportunidad para contar una historia única.
              </p>
              <p>
                Creo firmemente que las mejores fotografías nacen de la conexión genuina con mis 
                clientes. Por eso, mi enfoque siempre es crear un ambiente relajado y natural que 
                permita capturar la esencia de cada momento.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-border">
              {stats.map((stat, index) => (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.1 * index }}
                  className="text-center"
                >
                  <stat.icon className="w-5 h-5 mx-auto mb-2 text-muted-foreground" />
                  <div className="font-serif text-2xl md:text-3xl mb-1">{stat.value}</div>
                  <div className="text-xs text-muted-foreground">{stat.label}</div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
